import { useScrollReveal } from '../../../hooks/useScrollReveal';
import { pressFeatures } from '../../../mocks/altaCostura';

export default function PressSection() {
  const { ref, isVisible, style } = useScrollReveal({ threshold: 0.1, distance: 36, duration: 900 });

  return (
    <section ref={ref} className="w-full bg-brand-cream py-20 md:py-28">
      <div className="px-6 lg:px-[7%]">
        <div className="text-center max-w-2xl mx-auto" style={style}>
          <span className="font-sans text-brand-gray-400 text-[11px] tracking-[0.2em] uppercase font-medium">
            Prensa Internacional
          </span>
          <h2 className="font-serif text-brand-black text-[clamp(2rem,4vw,3rem)] font-semibold leading-[1.15] mt-4">
            En las
            <span className="italic text-brand-gray-300"> Revistas</span>
          </h2>
          <p className="font-sans text-brand-gray-500 text-[15px] leading-[1.8] mt-4">
            Reconocimiento internacional en las publicaciones de moda más prestigiosas.
          </p>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {pressFeatures.map((feature, index) => (
            <div
              key={feature.magazine}
              className="bg-white rounded-3xl p-8 md:p-10"
              style={isVisible ? {
                opacity: 1,
                transform: 'translateY(0px)',
                transition: `opacity 900ms cubic-bezier(0.25, 0.46, 0.45, 0.94) ${200 + index * 140}ms, transform 900ms cubic-bezier(0.25, 0.46, 0.45, 0.94) ${200 + index * 140}ms`,
              } : {
                opacity: 0,
                transform: 'translateY(36px)',
                transition: `opacity 900ms cubic-bezier(0.25, 0.46, 0.45, 0.94) ${200 + index * 140}ms, transform 900ms cubic-bezier(0.25, 0.46, 0.45, 0.94) ${200 + index * 140}ms`,
                willChange: 'opacity, transform',
              }}
            >
              <span className="font-sans text-brand-black text-xs tracking-[0.2em] uppercase font-bold">
                {feature.magazine}
              </span>
              <p className="font-serif text-brand-gray-600 text-lg leading-[1.7] mt-6 italic">
                &ldquo;{feature.quote}&rdquo;
              </p>
              <span className="font-sans text-brand-gray-400 text-sm mt-6 block">
                {feature.year}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}